<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :modal_title="modal_title"
        :button_name="'Crear ' + modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        :emitters="emitters"
        @updateDialog="updateDialog"
        @loadList="filterList"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-combobox
            v-model="emitter_selected"
            autocomplete="off"
            item-text="name"
            item-value="id"
            :items="emitters"
            label="Emisor"
            class="mr-5"
            single-line
            hide-details
            clearable
            return-object
            @change="filterList"
          ></v-combobox>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.emitter ? props.item.emitter.name : "-" }}</td>
              <td class="text-center">{{ props.item.items ? props.item.items.length : 0 }}</td>
              <td class="text-center">{{ props.item.enabled ? "Sí" : "No" }}</td>
              <td class="text-center px-0" style="min-width: 100px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Búsqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { emmiterService } from "@/libs/ws/emmiterService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";

export default {
  components: { Title, Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      parent: this,
      service: generalService,
      page_title: "Plantillas de Asientos",
      modal_title: "Plantilla de Asiento",
      emitters: [],
      emitter_selected: null,
      mainItem: {
        id: 0,
        emitter: null,
        description: "",
        enabled: true,
        items: [],
      },
      defaultItem: null,
      headers: [
        { text: "Descripción", align: "left", sortable: true, value: "description" },
        { text: "Emisor", align: "left", sortable: true, value: "emitter.name" },
        { text: "Ítems", align: "center", sortable: false, value: "" },
        { text: "Habilitada", align: "center", sortable: true, value: "enabled" },
        { text: "Acción", align: "center", value: "" },
      ],
      list: [],
      dialog_delete: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    emmiterService.filter({ enabled: true }).then((response) => {
      this.emitters = response.result || [];
    });
    this.filterList();
  },
  methods: {
    getFilterParams() {
      return {
        emitter: this.emitter_selected != null ? this.emitter_selected.id : null,
      };
    },
    filterList() {
      this.service.setSection(Constant.SECTION_ASIENTO_TEMPLATES);
      this.loadList(this.service, this.getFilterParams());
    },
    deleteItemConfirm() {
      this.service.setSection(Constant.SECTION_ASIENTO_TEMPLATES);
      this.delete(this.service);
      this.dialog_delete = false;
      this.filterList();
    },
  },
};
</script>
